<template>
  <div>
    <Breadcrumb v-if="!$route.path.includes('list')" :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="formGroups"
      :viewMode="viewMode" @onChange="onChange">
    </MyForm>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'custom',
      breadcrumb: [
        { name: "客户管理", path: `/customer/manage` },
        { name: "客户列表", path: `/customer/manage` },
        { name: "客户添加" },
      ],
      form: {
        name: undefined,
        tradeid: undefined,
        member: undefined,
        phone: undefined,
        product: undefined,
        address: undefined,
        is_status: '在用',
      },
      rules: {
        name: [
          { required: true, message: "请填写公司名称", trigger: "blur" },
        ],
        is_status: [
          { required: true, message: "请选择客户状态", trigger: "blur" },
        ],
        // tradeid: [
        //   { required: true, message: "请选择所属行业", trigger: "blur" },
        // ],
        member: [
          { required: true, message: "请填写联系人", trigger: "blur" },
        ],
        phone: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
        // product: [
        //   { required: true, message: "请填写主营业务", trigger: "blur" },
        // ],
        address: [
          { required: true, message: "请填写公司地址", trigger: "blur" },
        ],
        username: [
          { required: true, message: "请填写用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
      },
      formGroups: [],
      formCtrl: [
        {
          label: "公司名称",
          keyName: "name",
          err: "请填写公司名称",
          type: "text",
        },
        {
          label: "所属车队长",
          keyName: "fleetname",
          type: "select",
          options: [],
        },
        {
          label: "客户状态",
          keyName: "is_status",
          type: "select",
          options: [
            { label: '在用', value: '在用' },
            { label: '停用', value: '停用' },
          ],
        },
        {
          label: "公司地址",
          keyName: "address",
          err: "请填写公司地址",
          type: "text",
        },
        // {
        //   label: "成立时间",
        //   keyName: "starttime",
        //   err: "请选择成立时间",
        //   type: "month",
        // },
        {
          label: "联系人",
          keyName: "member",
          err: "请填写联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "phone",
          err: "请填写联系电话",
          type: "text",
        },
        {
          label: "所属行业",
          keyName: "tradename",
          type: "select",
          options: [],
        },
        {
          label: "主营业务",
          keyName: "product",
          err: "请填写主营业务",
          type: "text",
        },
        // {
        //   label: "QQ",
        //   keyName: "qq",
        //   err: "请填写QQ",
        //   type: "number",
        // },
        // {
        //   label: "微信",
        //   keyName: "wechat",
        //   err: "请填写微信号",
        //   type: "text",
        // },
        // {
        //   label: "客户来源",
        //   keyName: "custcurse",
        //   type: "select",
        //   options: [],
        // },
        // {
        //   label: "跟进状态",
        //   keyName: "followstate",
        //   type: "select",
        //   options: [],
        // },
        // {
        //   label: "客户属性",
        //   keyName: "custtype",
        //   type: "select",
        //   options: [],
        // },
        // {
        //   label: "成交状态",
        //   keyName: "status",
        //   type: "select",
        //   options: [],
        // },
        // {
        //   label: "注意事项",
        //   keyName: "careful",
        //   err: "请填写注意事项",
        //   type: "textarea",
        // },
      ],
      getOptionUrl: 'index',
      team: [],
      industry: [],
    };
  },
  methods: {
    onChange({ key, value }) {
      if (key === 'fleetname') {
        // console.log('onChange', key, value)
        this.$set(this.form, key, value)
        this.team.map(v => {
          if (v.nickname === value) {
            this.$set(this.form, 'fleet', v.id)
          }
        })
        // console.log(this.form[key])
      } else if (key === 'tradename') {
        // console.log('onChange', key, value)
        this.$set(this.form, key, value)
        this.industry.map(v => {
          if (v.name === value) {
            this.$set(this.form, 'tradeid', v.id)
          }
        })
        // console.log(this.form[key])
      }

      console.log('form', { ...this.form })
    },

    setDetail() {
      if (this.detail) {
        this.form = { ...this.detail }
      }

      this.setFleet()
      this.setIndustry()

      this.$forceUpdate()
      // console.log('detail', { ...this.detail })
      // console.log('form', { ...this.form })
    },
    setOptions({ team, industry, customcur, followstate, customtype }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'fleetname' && team && team.length) {
          this.team.push(...team)
          c.options = team.map(v => {
            return {
              label: v.nickname,
              value: v.nickname,
            }
          })

          if (this.user.user_group_id == 5) {
            this.$set(this.form, 'fleet', this.user.id)
            this.$set(this.form, 'fleetname', this.user.nickname)
          } else {
            // this.$set(this.form, c.keyName, c.options[0].value)
            this.setFleet()
          }
        }
        if (c.keyName == 'tradename' && industry && industry.length) {
          this.industry.push(...industry)
          c.options = industry.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })

          this.setIndustry()
        }
        if (c.keyName == 'custcurse' && customcur && customcur.length) {
          c.options = customcur.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
          this.$set(this.form, c.keyName, c.options[0].value)
        }
        if (c.keyName == 'followstate' && followstate && followstate.length) {
          c.options = followstate.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
          this.$set(this.form, c.keyName, c.options[0].value)
        }
        if (c.keyName == 'custtype' && customtype && customtype.length) {
          c.options = customtype.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
          this.$set(this.form, c.keyName, c.options[0].value)
        }
        this.$forceUpdate()
      })

      // console.log('form', { ...this.form })
    },

    setFleet() {
      const { fleet } = this.detail
      if (this.team && this.team.length) {
        this.team.map(v => {
          if (v.id == fleet) {
            this.$set(this.form, 'fleet', v.id)
            this.$set(this.form, 'fleetname', v.nickname)
          }
        })
      }
    },
    setIndustry() {
      const { tradeid } = this.detail
      if (this.industry && this.industry.length) {
        this.industry.map(v => {
          if (v.id == tradeid) {
            this.$set(this.form, 'tradeid', v.id)
            this.$set(this.form, 'tradename', v.name)
          }
        })
      }
    },

    paramsPackage(params, object) {
      const keys = [
        'userid',
        'id',
        'name',
        'fleet',
        'is_status',
        'address',
        'member',
        'phone',
        'tradeid',
        'product',
        'username',
        'password',
      ]
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && keys.includes(key)) {
          // console.log(key, object[key], typeof object[key])
          // const value = object[key]
          // params[key] = value;
          this.$set(params, key, object[key])
        }
      }
      // console.log('params', { ...params })
    },
  },
  created() {
    const arr = [
      {
        title: '基础信息',
        formCtrl: [...this.formCtrl],
      },
      {
        title: '账号信息',
        formCtrl: [
          {
            label: "用户名",
            keyName: "username",
            err: "请填写用户名",
            type: "text",
            disabled: !!this.$route.query.id, // 有id则说明是编辑，禁止修改用户名
          },
          {
            label: "密码",
            keyName: "password",
            err: "请填写密码",
            type: "password",
          },
        ],
      },
    ]
    this.formGroups.push(...arr)
  },
  mounted() {
    this.getOptions();
    const { user_group_id } = this.user
    if (user_group_id == 5) {
      this.formCtrl.map(v => {
        if (v.keyName === 'fleetname') {
          v.disabled = true
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
